import { DeviseResource } from "types/centre.type";
import { CrudService } from "./crudService";

const crud = new CrudService<DeviseResource, DeviseResource>("devises");

export const deviseService = {
  ...crud,
};
